<template>
  <v-card>
    <!-- キャプション -->
    <v-card-title>{{caption}}</v-card-title>

    <v-card-text>
      <!-- コンテンツ -->
      <slot/>

      <!-- アクション -->
      <div class="text-right mt-4">
        <slot name="actions"/>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'CPanel',
  props: {
    caption: {
      type: String,
      required: true
    }
  }
}
</script>
